import { Component } from '@angular/core';
import { addIcons } from 'ionicons';
import { logoWhatsapp } from 'ionicons/icons';
import { IonFab, IonFabButton, IonIcon } from '@ionic/angular/standalone';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-whatsapp-fab',
  standalone: true,
  imports: [IonFab, IonFabButton, IonIcon,CommonModule],
  templateUrl: './whatsapp-fab.component.html',
  styleUrls: ['./whatsapp-fab.component.scss']
})
export class WhatsappFabComponent {

  constructor() {
    addIcons({ logoWhatsapp });
  }

  public isBlueBackground = true;

  openWhatsapp() {
    const phoneNumber = '525591991913';
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, '_blank');
  }
}